export default "__VITE_ASSET__Cqt9goqH__"